<template>
    <v-container>
      <v-card class="pa-4">
        <v-card-title>Parent Arrival Notification Template</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-textarea
              label="Notification Message Template"
              v-model="form.message"
              :rules="[v => !!v || 'Template cannot be empty']"
              :hint="`Use placeholder: {{parent_name}}`"
              persistent-hint
              rows="4"
              auto-grow
            ></v-textarea>
  
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.scheduled_time"
                  label="Scheduled Time"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[v => !!v || 'Time is required']"
                ></v-text-field>
              </template>
              <v-time-picker v-model="form.scheduled_time" @change="menu = false" format="24hr"></v-time-picker>
            </v-menu>
  
            <v-btn color="primary" class="mt-4" @click="submit" :disabled="!valid">Save Template</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
  
      <v-snackbar v-model="snackbar" color="success">{{ snackbarText }}</v-snackbar>
    </v-container>
  </template>
  
  <script>
import axios from 'axios';

  export default {
    data() {
      return {
        valid: false,
        menu: false,
        snackbar: false,
        snackbarText: '',
        form: {
          message: '',
          scheduled_time: '',
        },
      };
    },
    methods: {
      async submit() {
        if (!this.$refs.form.validate()) return;
          const schoolId =  localStorage.getItem('user_id');
          const payload = {
          ...this.form,
          school_id: schoolId
        };
        try {
          const response = await  axios.post('/timenotification/createTimeNotification', payload);
          if(response.data.status){
            this.snackbarText = 'Template saved successfully!';
            this.snackbar = true;
            this.$router.push({ name: 'templatelistfortimenotification' });
          }else{
            this.snackbarText = 'Failed to save template.';
            this.snackbar = true;
          }
        } catch (error) {
          console.error(error);
          this.snackbarText = error.response.data.message || 'Failed to save template.';
          this.snackbar = true;
        }
      },
    },
  };
  </script>
  